import { createElement } from 'react';
import { Table, Box } from '@alifd/next';
import './index.scss';
const OadpTable = function OadpTable({ dataSource, onRowClick, children, locale, ...otherProps }) {
    return (createElement(Box, null,
        createElement(Table, Object.assign({ dataSource: dataSource, onRowClick: onRowClick }, otherProps), children)));
};
export default OadpTable;
